export default "__VITE_ASSET__BmNyV2ib__"